export default __webpack_public_path__ + "static/media/leftScrollIcon.aa16fb51.svg";